/* ==========================================================================
   SECRET SPY RECORDER PRO — interaction + motion layer
   No dependencies. Every effect degrades gracefully and everything respects
   prefers-reduced-motion. Rebuilt after a code audit; the numbered comments
   mark the fixes so they do not regress.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  /* ── scroll coalescing that cannot deadlock ──────────────────────────
     rAF is used to coalesce bursts of scroll events, but it is never the only
     path: if the frame callback does not arrive (background tab, headless,
     throttled webview) a timeout runs the work anyway. The old `ticking`
     guard cleared only inside rAF, so a single missed frame killed scroll
     handling permanently. */
  function onScroll(fn) {
    var pending = false;
    return function () {
      if (pending) { return; }
      pending = true;
      var done = false;
      var run = function () {
        if (done) { return; }
        done = true;
        pending = false;
        fn();
      };
      window.requestAnimationFrame(run);
      setTimeout(run, 100);          // guarantee: never stuck on a lost frame
    };
  }

  /* ── entrance trigger ──────────────────────────────────────────────────
     IntersectionObserver is the primary trigger, but it is not the only one:
     in headless Chrome (and in some embedded webviews) the observer never
     fires, which left every reveal, counter and ladder bar stuck at its
     initial state - i.e. an invisible page. A rAF-throttled
     getBoundingClientRect sweep acts as the guaranteed second trigger. */
  var watchers = [];
  var sweeping = false;

  function onEnter(el, cb, threshold, margin) {
    if (!el || el.dataset.entered) { return; }
    var done = false, io = null;
    function fire() {
      if (done) { return; }
      done = true;
      el.dataset.entered = '1';
      if (io) { io.disconnect(); }
      cb(el);
    }
    try {
      io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) { fire(); return; }
        }
      }, { rootMargin: '0px 0px ' + (margin || '-9%') + ' 0px', threshold: threshold || 0.06 });
      io.observe(el);
    } catch (err) { /* no IntersectionObserver - sweep covers it */ }
    watchers.push({ el: el, fire: fire });
  }

  function sweep() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var keep = [];
    for (var i = 0; i < watchers.length; i++) {
      var w = watchers[i];
      var r = w.el.getBoundingClientRect();
      if (r.top < vh * 0.97 && r.bottom > -60) { w.fire(); } else { keep.push(w); }
    }
    watchers = keep;
  }

  /* ── product data (mirrors the Shopify product JSON) ───────────────── */
  var VARIANTS = [
    { id: '50749996106006', label: '16GB', sub: 'Up to 8 days of recordings',
      hours: 192, days: 'up to 8 days',  price: 999, was: 3499 },
    { id: '50749996138774', label: '32GB', sub: 'Up to 16 days of recordings',
      hours: 384, days: 'up to 16 days', price: 999, was: 3499 }
  ];
  /* ── STORE CONFIG ─────────────────────────────────────────────────────
     The only thing still pointing at the original host. Every "Add to cart"
     button becomes <CART_BASE><variantId>:<qty>, which is Shopify's cart
     permalink and works today. When the Restilux storefront is live, change
     this ONE line (e.g. 'https://restilux.com/cart/') - nothing else needs
     touching. Variant IDs below are the real Shopify variant IDs.          */
  var CART_BASE = 'https://restilux.com/cart/';
  var state = { vi: 0, qty: 1 };

  var inr = function (n) {
    return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var cartUrl = function () {
    return CART_BASE + VARIANTS[state.vi].id + ':' + state.qty;
  };

  /* ── 1. loader ─────────────────────────────────────────────────────────
     FIX 1: the scroll lock lives on <html class="js-loading"> (added by an
     inline <head> script so it cannot trap anyone with JS disabled). That
     class MUST be removed here, or the page can never scroll again.        */
  (function loader() {
    var el = $('#loader');
    if (!el) { return; }
    var bar = $('.loader__bar i', el);
    var pct = $('.loader__pct', el);
    var p = 0;
    var tick = setInterval(function () {
      p = Math.min(100, p + Math.random() * 17 + 6);
      if (bar) { bar.style.transform = 'scaleX(' + (p / 100) + ')'; }
      if (pct) { pct.textContent = String(Math.floor(p)).padStart(3, '0') + ' / 100'; }
      if (p >= 100) { done(); }
    }, REDUCED ? 30 : 130);

    var bail = setTimeout(done, 3200);   // never trap the user behind a loader

    function done() {
      clearInterval(tick);
      clearTimeout(bail);
      if (el.dataset.done) { return; }
      el.dataset.done = '1';
      document.documentElement.classList.remove('js-loading');   // FIX 1
      document.body.classList.remove('is-locked');
      el.classList.add('is-done');
      setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 900);
      boot();
    }
  }());

  /* ── 2. reveal system ──────────────────────────────────────────────── */
  function splitLines() {
    $$('.split').forEach(function (h) {
      if (h.dataset.split === 'done') { return; }
      h.dataset.split = 'done';
      var parts = h.innerHTML.split(/<br\s*\/?>/i);
      h.innerHTML = parts.map(function (line, i) {
        return '<span class="line" style="--d:' + (i * 0.09) + 's"><span>' + line + '</span></span>';
      }).join('');
    });
  }

  function initReveal() {
    splitLines();
    $$('[data-rv], .split').forEach(function (el) {
      onEnter(el, function (t) { t.classList.add('is-in'); }, 0.06, '-9%');
    });
  }

  /* ── 3. marquee rows ───────────────────────────────────────────────────
     The CSS animates 0 -> -50%, so a row needs EXACTLY two identical copies.
     One clone pass is enough; no ids exist inside the cards.               */
  function initMarquees() {
    $$('.rev__row').forEach(function (row) {
      Array.prototype.slice.call(row.children).forEach(function (k) {
        var c = k.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        row.appendChild(c);
      });
    });
  }

  /* ── 4. chrome: progress, sticky header, sticky buy bar ────────────────
     FIX 4: the old "nearEnd" pixel check let the sticky bar sit on top of the
     final Add-to-cart CTA. Now an IntersectionObserver hides it whenever the
     closing CTA is actually on screen.                                     */
  function initChrome() {
    var bar = $('#progress');
    var hdr = $('#hdr');
    var buybar = $('#buybar');
    var hero = $('#hero');
    var finalRow = $('.final__row');
    var ctaVisible = false;
    var ticking = false;

    // Show the bar whenever the page's own buy button is off-screen (above or below),
    // not only after the whole hero has scrolled away - on phones the hero is several screens tall.
    var buyForm = $('#product-form');
    var formVisible = true;
    if (buybar && buyForm) {
      new IntersectionObserver(function (entries) {
        formVisible = entries[0].isIntersecting;
        sync();
      }).observe(buyForm);
    }

    if (buybar && finalRow) {
      new IntersectionObserver(function (entries) {
        ctaVisible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15 }).observe(finalRow);
    }

    function sync() {
      var y = window.scrollY || document.documentElement.scrollTop;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (bar) { bar.style.transform = 'scaleX(' + (h > 0 ? clamp(y / h, 0, 1) : 0) + ')'; }
      if (hdr) { hdr.classList.toggle('is-stuck', y > 24); }
      if (buybar && hero) {
        buybar.classList.toggle('is-on', (buyForm ? !formVisible && y > 300 : y > hero.offsetHeight * 0.82) && !ctaVisible);
      }
    }

    window.addEventListener('scroll', onScroll(sync), { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  /* ── 5. hero: parallax + waveform ──────────────────────────────────────
     FIX 3: `.stage__device` used to carry the `floaty` keyframe AND receive
     the JS transform. Animation declarations outrank inline styles, so the
     parallax never rendered. The float now lives on the inner <img> and the
     JS transform on the wrapper.                                           */
  function initHero() {
    var stage = $('#stage');
    var device = $('#device');
    if (stage && device && !REDUCED) {
      var mx = 0, my = 0, cx = 0, cy = 0;
      window.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        mx = ((e.clientX - (r.left + r.width / 2)) / r.width) * 22;
        my = ((e.clientY - (r.top + r.height / 2)) / r.height) * 18;
      }, { passive: true });
      (function loop() {
        cx += (mx - cx) * 0.06;
        cy += (my - cy) * 0.06;
        device.style.transform = 'translate3d(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px,0)';
        requestAnimationFrame(loop);
      }());
      var chips = $$('.stage__chip');
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        chips.forEach(function (c, i) {
          c.style.marginTop = (-y * (0.05 + i * 0.03)).toFixed(1) + 'px';
        });
      }, { passive: true });
    }

    var thumbs = $$('.stage__thumb');
    var heroImgEl = $('#heroImg');
    if (thumbs.length && heroImgEl) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          if (!src) { return; }
          heroImgEl.src = src;
          thumbs.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-current', 'false'); });
          t.classList.add('is-on');
          t.setAttribute('aria-current', 'true');
        });
      });
    }

    var wave = $('#wave');
    if (wave && !wave.dataset.built) {
      wave.dataset.built = '1';
      var N = 46;
      for (var i = 0; i < N; i++) {
        var b = document.createElement('i');
        var mid = Math.abs(i - (N - 1) / 2) / ((N - 1) / 2);
        b.style.height = (14 + (1 - mid) * 72) + '%';
        b.style.animation = 'wf 1.1s ease-in-out ' + (i * 0.045).toFixed(2) + 's infinite alternate';
        wave.appendChild(b);
      }
      if (!document.getElementById('wfkf')) {
        var st = document.createElement('style');
        st.id = 'wfkf';
        st.textContent = '@keyframes wf{from{transform:scaleY(.24);opacity:.5}to{transform:scaleY(1);opacity:1}}';
        document.head.appendChild(st);
      }
    }
  }

  /* ── 6. count-up ───────────────────────────────────────────────────── */
  function initCounters() {
    $$('[data-count]').forEach(function (el) {
      onEnter(el, function (t) {
        var to = parseFloat(t.dataset.count);
        var dec = (t.dataset.dec | 0);
        var suf = t.dataset.suffix || '';
        if (REDUCED) { t.textContent = to.toFixed(dec) + suf; return; }
        var t0 = performance.now(), dur = 1500, fin = false;
        function write(v) { if (!fin) { t.textContent = v; } }
        (function step(now) {
          var k = clamp((now - t0) / dur, 0, 1);
          write((to * (1 - Math.pow(1 - k, 3))).toFixed(dec) + suf);
          if (k < 1) { requestAnimationFrame(step); } else { fin = true; }
        }(t0));
        // requestAnimationFrame is throttled in background tabs, low-power mode
        // and headless rendering. This guarantees the real figure lands - and
        // `fin` stops a late frame from overwriting it back to 0.
        setTimeout(function () {
          fin = true;
          t.textContent = to.toFixed(dec) + suf;
        }, dur + 600);
      }, 0.4, '0px');
    });
  }

  /* ── 7. buy box ────────────────────────────────────────────────────── */
  function renderBuy() {
    // VARIANTS is the Recorder Pro's hardcoded data. On every other product the
    // Liquid-rendered price is the truth, so never overwrite it.
    if (!/\/products\/restilux-recorder-pro/.test(location.pathname)) { return; }
    var v = VARIANTS[state.vi];
    var set = function (sel, txt) { var el = $(sel); if (el) { el.textContent = txt; } };
    set('#priceNow', inr(v.price));
    set('#priceWas', inr(v.was));
    set('#priceSave', 'Save ' + inr(v.was - v.price));
    set('#buybarPrice', inr(v.price));
    set('#buybarVariant', v.label + ' · ' + v.sub);
    set('#buybarShort', v.label);   /* PATCH 6 - the label shown on mobile */
    set('#qtyVal', String(state.qty));
    set('#ctaPrice', inr(v.price));
    set('#capSel', v.label + ' — ' + v.days);
    set('#priceOff', '−' + Math.round(((v.was - v.price) / v.was) * 100) + '%');
    $$('.js-cart').forEach(function (a) { a.setAttribute('href', cartUrl()); });
    $$('#ladder .cap__row').forEach(function (r) {
      r.classList.toggle('is-active', parseInt(r.dataset.hours, 10) === v.hours);
    });
  }

  function initBuy() {
    $$('#optGrid .opt').forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        state.vi = i;
        $$('#optGrid .opt').forEach(function (b, j) {
          b.setAttribute('aria-pressed', String(i === j));
        });
        renderBuy();
        toast(VARIANTS[i].label + ' selected', VARIANTS[i].sub);
      });
    });
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = clamp(state.qty + parseInt(b.dataset.qty, 10), 1, 10);
        renderBuy();
      });
    });
    $$('.js-cart').forEach(function (a) {
      a.addEventListener('click', function () {
        if (/\/products\/restilux-recorder-pro/.test(location.pathname)) { toast('Adding to cart…', VARIANTS[state.vi].label + ' × ' + state.qty); }
      });
    });
    renderBuy();
  }

  /* ── 8. capacity ladder ────────────────────────────────────────────── */
  function initLadder() {
    var l = $('#ladder');
    if (!l) { return; }
    onEnter(l, function (t) {
      $$('.cap__track i', t).forEach(function (b, i) {
        setTimeout(function () { b.style.width = b.dataset.w + '%'; }, REDUCED ? 0 : i * 130);
      });
    }, 0.3, '0px');
  }

  /* ── 9. cinematic reel ─────────────────────────────────────────────────
     FIX 2: the progress fill is `#reelBar` itself, not a child of it.
     FIX 8: the dots are real <button>s, so they are focusable and operable.
     FIX 9: the rAF loop starts and stops with playback (no idle spin) and
     resuming no longer rewinds the fill.                                   */
  function initReel() {
    var frame = $('#reel');
    if (!frame) { return; }
    var slides = $$('.reel__slide', frame);
    var dots = $$('.reel__dots button', frame);
    var cap = $('#reelCap');
    var fill = $('#reelBar');                    // FIX 2
    var btn = $('#reelBtn');
    var DUR = 4200;
    var i = 0, playing = false, elapsed = 0, last = 0, raf = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (cap) { cap.textContent = slides[i].dataset.cap || ''; }
      elapsed = 0; last = 0;
      if (fill) { fill.style.transform = 'scaleX(0)'; }
    }

    function loop(now) {
      if (!playing) { raf = null; return; }      // FIX 9: no idle rAF
      if (!last) { last = now; }
      elapsed += now - last;
      last = now;
      if (elapsed >= DUR) { show(i + 1); }
      if (fill) { fill.style.transform = 'scaleX(' + clamp(elapsed / DUR, 0, 1) + ')'; }
      raf = requestAnimationFrame(loop);
    }

    function paintBtn() {
      if (!btn) { return; }
      btn.setAttribute('aria-label', playing ? 'Pause the reel' : 'Play the reel');
      btn.innerHTML = playing
        ? '<svg viewBox="0 0 12 14"><rect x="0" y="0" width="4" height="14"/><rect x="8" y="0" width="4" height="14"/></svg>'
        : '<svg viewBox="0 0 12 14"><path d="M0 0l12 7-12 7z"/></svg>';
    }
    function play() {
      if (playing) { return; }
      playing = true;
      last = 0;                                  // resume, do not rewind
      if (raf === null) { raf = requestAnimationFrame(loop); }
      paintBtn();
    }
    function pause() { playing = false; paintBtn(); }

    show(0);
    if (REDUCED) { pause(); } else { play(); }
    if (btn) { btn.addEventListener('click', function () { if (playing) { pause(); } else { play(); } }); }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function (e) { e.stopPropagation(); show(k); });
    });
  }

  /* ── 10. gallery lightbox ──────────────────────────────────────────────
     FIX 5: focus returns to the thumbnail that opened the dialog.          */
  function initGallery() {
    var lb = $('#lb'), img = $('#lbImg'), cap = $('#lbCap');
    if (!lb || !img) { return; }
    var btns = $$('#gal button');
    var cur = 0, trigger = null;

    function open(n, from) {
      cur = (n + btns.length) % btns.length;
      var b = btns[cur];
      trigger = from || b;
      img.src = b.dataset.full;
      img.alt = b.dataset.cap || '';
      if (cap) { cap.textContent = (b.dataset.cap || '') + '  ·  ' + (cur + 1) + ' / ' + btns.length; }
      lb.classList.add('is-on');
      document.body.classList.add('is-locked');
      var x = $('#lbX');
      if (x) { x.focus(); }
    }
    function close() {
      lb.classList.remove('is-on');
      document.body.classList.remove('is-locked');
      if (trigger && trigger.focus) { trigger.focus(); }   // FIX 5
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { open(i, b); });
    });
    $('#lbX').addEventListener('click', close);
    $('#lbP').addEventListener('click', function () { open(cur - 1); });
    $('#lbN').addEventListener('click', function () { open(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) { close(); } });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-on')) { return; }
      if (e.key === 'Escape') { close(); }
      if (e.key === 'ArrowLeft') { open(cur - 1); }
      if (e.key === 'ArrowRight') { open(cur + 1); }
    });
  }

  /* ── 11. accordion ─────────────────────────────────────────────────────
     FIX 6: collapsed answers are marked `inert` so screen readers and Tab
     skip them, and the fixed pixel height is recalculated on resize.       */
  function initAccordion() {
    $$('.acc').forEach(function (acc, idx) {
      var q = $('.acc__q', acc), a = $('.acc__a', acc);
      if (!q || !a) { return; }
      var id = 'acc-panel-' + idx;
      a.id = id;
      q.setAttribute('aria-controls', id);
      q.setAttribute('aria-expanded', 'false');
      a.inert = true;
      q.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        q.setAttribute('aria-expanded', String(open));
        a.inert = !open;
        a.style.height = open ? a.scrollHeight + 'px' : '0px';
      });
    });
    var first = $('.acc');
    if (first) { $('.acc__q', first).click(); }
    window.addEventListener('resize', function () {
      $$('.acc.is-open .acc__a').forEach(function (a) { a.style.height = a.scrollHeight + 'px'; });
    }, { passive: true });
  }

  /* ── 12. toast ─────────────────────────────────────────────────────── */
  var toastT = null;
  function toast(title, sub) {
    var t = $('#toast');
    if (!t) { return; }
    var tt = $('#toastT'), ts = $('#toastS');
    if (tt) { tt.textContent = title; }
    if (ts) { ts.textContent = sub || ''; }
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ── 13. smooth anchors ────────────────────────────────────────────── */
  function initAnchors() {
    $$('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (!id || id === '#' || id.length < 2) { return; }
        var t = document.querySelector(id);
        if (!t) { return; }
        e.preventDefault();
        window.scrollTo({
          top: t.getBoundingClientRect().top + window.scrollY - 70,
          behavior: REDUCED ? 'auto' : 'smooth'
        });
      });
    });
  }

  /* ── boot ──────────────────────────────────────────────────────────── */
  var booted = false;
  /* ── 12. pinned cinematic sequence ─────────────────────────────────────
     The scroll-scrubbed timeline. `is-live` is added here and only here, so
     the section's real content - four factual chapters - is what renders when
     JS is unavailable or motion is reduced. Nothing is hidden by default. */
  function initCine() {
    var sec = $('#cine');
    if (!sec || REDUCED) { return; }
    var dev = $('#cineDev', sec);
    var chs = $$('.cine__ch', sec);
    var rail = $('#cineRail', sec);
    if (!dev || chs.length < 2) { return; }

    sec.classList.add('is-live');

    var N = chs.length;
    // per-chapter device pose: rotateY / translateY / scale
    var POSE = [
      { ry: -24, ty: 26, sc: 0.90 },
      { ry:  -6, ty:  0, sc: 1.00 },
      { ry:  20, ty: -12, sc: 1.05 },
      { ry:   8, ty: 10, sc: 1.12 }
    ];
    var ticking = false;

    function sync() {
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var span = r.height - vh;
      var p = span > 0 ? clamp(-r.top / span, 0, 1) : 0;

      var seg = 1 / N;
      var i = Math.min(N - 1, Math.floor(p / seg));
      var local = clamp((p - i * seg) / seg, 0, 1);
      // ease each segment so chapters settle instead of snapping
      var e = local < 0.5 ? 2 * local * local : 1 - Math.pow(-2 * local + 2, 2) / 2;

      var a = POSE[i], b = POSE[Math.min(N - 1, i + 1)];
      var s = sec.style;
      s.setProperty('--ry', (a.ry + (b.ry - a.ry) * e).toFixed(2));
      s.setProperty('--ty', (a.ty + (b.ty - a.ty) * e).toFixed(2));
      s.setProperty('--sc', (a.sc + (b.sc - a.sc) * e).toFixed(3));
      s.setProperty('--p',  p.toFixed(4));

      // staged reveals, each keyed to its own window of the scroll
      s.setProperty('--d1', clamp((p - 0.12) / 0.10, 0, 1).toFixed(3));  // dimensions
      s.setProperty('--d2', clamp((p - 0.36) / 0.10, 0, 1).toFixed(3));  // mass badge
      s.setProperty('--d3', clamp((p - 0.58) / 0.10, 0, 1).toFixed(3));  // macro insets

      for (var k = 0; k < N; k++) { chs[k].classList.toggle('is-on', k === i); }
      if (rail) { rail.style.transform = 'scaleY(' + p.toFixed(4) + ')'; }
    }

    window.addEventListener('scroll', onScroll(sync), { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function boot() {
    if (booted) { return; }
    booted = true;
    initReveal();
    initMarquees();
    initChrome();
    initHero();
    initCounters();
    initBuy();
    initLadder();
    initReel();
    initCine();
    initGallery();
    initAccordion();
    initAnchors();

    // guaranteed second trigger - see onEnter()
    sweep();
    window.addEventListener('scroll', onScroll(sweep), { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
    window.addEventListener('load', sweep);
    setTimeout(sweep, 350);
    setTimeout(sweep, 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!document.getElementById('loader')) { boot(); }
    });
  } else if (!document.getElementById('loader')) {
    boot();
  }

  window.__ssr = { toast: toast, renderBuy: renderBuy };
}());
